export default __webpack_public_path__ + "static/media/perfil-2.668d8a10.png";